import React from 'react';
import TestSeriesList from "../components/TestSeriesList/TestSeriesList";
import { useAnalyticsPageView, useTestSeriesList } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from 'react-router-dom';
/**
 * Test series page
 * @param props
 * @returns {*}
 * @constructor
 */
function TestSeries(props) {
    const navigate = useNavigate();
    const { history } = props;
    const { testSeriesList, testSeriesLoading } = useTestSeriesList();
    //analytic
    useAnalyticsPageView();

    function gotoPage() {
        navigate('/my-app/tests');
    }

    return (
        <TestSeriesList
            testSeriesList={testSeriesList}
            testSeriesLoading={testSeriesLoading}
            handleTabChange={() => gotoPage()}
            showFooter={true}
        />
    );
}

export default TestSeries;
